import React, { useEffect } from "react";
import AssignStatusComponent from "../../components/applicationComponents/assignStatus/AssignStatusComponent";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
export default function AssignStatusPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Type of Application",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);
  return <AssignStatusComponent disabled={false} />;
}
